import { render, staticRenderFns } from "./GkLogo.vue?vue&type=template&id=6d82f838&scoped=true&"
import script from "./GkLogo.vue?vue&type=script&lang=js&"
export * from "./GkLogo.vue?vue&type=script&lang=js&"
import style0 from "./GkLogo.vue?vue&type=style&index=0&id=6d82f838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82f838",
  null
  
)

export default component.exports